
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.19 38.65c2.47 0 10.69-4.92 10.69-10.66V10.76H1.5V28c0 5.73 8.22 10.65 10.69 10.65z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M17.4 26.59a5.21 5.21 0 01-10.4 0zM12.19 10.74v12.24M22.56 27.17c2.07 1.49 4.19 2.39 5.25 2.39 2.47 0 10.69-4.92 10.69-10.66V1.68H17.12v8.94","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M23 19.1A5.21 5.21 0 0133 21h-9.75M27.81 1.65v10.56","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    